export const eventTracking = (
  _name: string,
  _payload?: Record<string, unknown>
) => {
  // no-op in clinic; replace with telemetry call when needed
}
